module.exports = __webpack_public_path__ + "img/mg-logo.78d94f3e.png";